import {z} from "zod";
import {imageSchema} from "@/images/ImageSchema.ts";

export const sceneSchema = z.object({
    id: z.uuid(),
    campaignId: z.uuid("Kampagne erforderlich"),
    name: z.string().trim().min(3, "Name erforderlich"),
    image: imageSchema,
});

export type SceneFormInput = z.input<typeof sceneSchema>;
export type SceneFormOutput = z.output<typeof sceneSchema>;
